import { GET_CONTACT_INVESTOR,GET_RECEIVE_EMAIL_INVESTOR,GET_CANCEL_EMAIL_INVESTOR } from "./actions.type";
import { contact } from "@/service/contact";

function initState() {
  return {}
}

const state = initState();

const actions = {
  async [GET_CONTACT_INVESTOR]({ }, data) {
    return await contact.getContactInvestor(data);
  },
  async [GET_RECEIVE_EMAIL_INVESTOR]({ }, data) {
    return await contact.getReceiveEemailsInvestor(data);
  },
  async [GET_CANCEL_EMAIL_INVESTOR]({ }, data) {
    return await contact.getCancelEemailsInvestor(data);
  },
};


const mutations = {};

const getters = {};

export default {
  state,
  actions,
  mutations,
  getters
};
